module.exports = __webpack_public_path__ + "img/sushe.61a66da4.png";